<!--
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
-->
<div class="wsn-container">
  <wsn-navbar-wrapper [showOptions]="true"></wsn-navbar-wrapper>

  <div *ngIf="showBanner" class="banner">
    <span class="banner-text">
      {{ banner.title }}&nbsp;
      <b
        ><u
          ><a *ngIf="banner.url" [href]="banner.url" target="_blank" rel="noopener noreferrer">{{ banner.text }}</a></u
        ></b
      >
      <span *ngIf="!banner.url">{{ banner.text }}</span>
    </span>
    <div class="banner-actions">
      <button class="close-btn" (click)="dismissBanner()">x</button>
    </div>
  </div>

  <wsn-tracking-banner-impersonation></wsn-tracking-banner-impersonation>

  <wsn-sidenav-wrapper #sidenavWrapper></wsn-sidenav-wrapper>
</div>
